var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVttKnittingIllustration01(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 661,
    height: 405,
    viewBox: "0 0 661 405",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "netewilfqa",
    d: "M0 0h615v318.983H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "hmnccs95nc",
    d: "M0 0h615v318.983H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "73oxhvrrwe",
    d: "M0 0h615v318.983H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ujcth5jy0g",
    d: "M0 0h615v318.983H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bud6ifiuci",
    d: "M0 0h591v405H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "re4djmvb6k",
    d: "M0 0h591v405H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "0wq6qpt2cm",
    d: "M0 0h591v405H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "gurugep1no",
    d: "M0 0h591v405H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ch7swusnnq",
    d: "M0 0h591v405H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "y6dyqdjqys",
    d: "M0 0h591v405H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "kbvuele7qu",
    d: "M0 0h591v405H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "idmob5zv9w",
    d: "M0 0h591v405H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "e9wr81qzmy",
    d: "M0 0h591v405H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "9yr0lydy7A",
    d: "M0 0h591v405H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "33virnz2iC",
    d: "M0 0h591v405H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "1rsr0pew2E",
    d: "M0 0h591v405H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "6oqudspqbG",
    d: "M0 0h591v405H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "d5wgsn451I",
    d: "M0 0h591v405H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fzdr7hqh4K",
    d: "M0 0h591v405H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "do0jl5h5rM",
    d: "M0 0h591v405H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "qxle8f2agO",
    d: "M0 0h591v405H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "uj392bsnvQ",
    d: "M0 0h591v405H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "4mci3d11dS",
    d: "M0 0h591v405H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "vg9sjhepgU",
    d: "M0 0h591v405H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "xxoziuhyvW",
    d: "M0 0h591v405H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "l0epu9igyY",
    d: "M0 0h591v405H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "5k2vmbe7uaa",
    d: "M0 0h591v405H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "smp6ki5c5ac",
    d: "M0 0h591v405H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "wq4nscc4nae",
    d: "M0 0h591v405H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "j2l1trth0ag",
    d: "M0 0h591v405H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "l16qglsm7ai",
    d: "M0 0h591v405H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "uc1yvfyrzak",
    d: "M0 0h591v405H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "wlt9488kxam",
    d: "M0 0h591v405H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "7152qnqm7ao",
    d: "M0 0h591v405H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "z5cwzryojaq",
    d: "M0 0h591v405H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "0u1dsznrfas",
    d: "M0 0h591v405H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pdgcqnsxuau",
    d: "M0 0h591v405H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p7t2qrnjpaw",
    d: "M0 0h591v405H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "b74x754mfay",
    d: "M0 0h591v405H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "51f23p7j2aA",
    d: "M0 0h591v405H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "1vl69oa9uaC",
    d: "M0 0h591v405H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fd36o4utaaE",
    d: "M0 0h591v405H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "i3sfwjutwaG",
    d: "M0 0h591v405H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "7und3x0vaaI",
    d: "M0 0h591v405H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "zarxznxxuaK",
    d: "M0 0h591v405H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "mudql72z8aM",
    d: "M0 0h591v405H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "l8nnj2b1paO",
    d: "M0 0h591v405H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bqh0owa0laQ",
    d: "M0 0h591v405H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "lf3o2bcp9aS",
    d: "M0 0h591v405H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "u7520dc7jaU",
    d: "M0 0h591v405H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "y11s90rk5aW",
    d: "M0 0h591v405H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ht7c1vtkdaY",
    d: "M0 0h591v405H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "y1ejrcmopba",
    d: "M0 0h591v405H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "7zir1o5cbbc",
    d: "M0 0h591v405H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "v0p69k3s0be",
    d: "M0 0h591v405H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "c3zb45hjrbg",
    d: "M0 0h591v405H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "u32us4pr9bi",
    d: "M0 0h591v405H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rha27grmdbk",
    d: "M0 0h591v405H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "uu5jzyev6bm",
    d: "M0 0h591v405H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "t2kvndpaabo",
    d: "M0 0h591v405H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "08heyux7rbq",
    d: "M0 0h591v405H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "uloyeuy2zbs",
    d: "M0 0h591v405H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "va2mbwvc3bu",
    d: "M0 0h591v405H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "zvex276pubw",
    d: "M0 0h591v405H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "werwx7rnoby",
    d: "M0 0h591v405H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "sq2n3d53dbA",
    d: "M0 0h591v405H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "4rmy3qw3sbC",
    d: "M0 0h591v405H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "6lwjroo0lbE",
    d: "M0 0h591v405H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "x6qaocfz0bG",
    d: "M0 0h591v405H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "4ndedsgwfbI",
    d: "M0 0h591v405H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "28x1xiq30bK",
    d: "M0 0h591v405H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "4anwef3cobM",
    d: "M0 0h591v405H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "g91vmg11mbO",
    d: "M0 0h591v405H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "19f0qgxh1bQ",
    d: "M0 0h591v405H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ec5w2xxm3bS",
    d: "M0 0h591v405H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "f4lg36hlqbU",
    d: "M0 0h591v405H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fakq3y8rqbW",
    d: "M0 0h591v405H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "1s70m695dbY",
    d: "M0 0h591v405H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "scdr4kbiqca",
    d: "M0 0h591v405H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cftymf1qlcc",
    d: "M0 0h591v405H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "tg65sf95kce",
    d: "M0 0h591v405H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "e13m1d175cg",
    d: "M0 0h591v405H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "hprxboy9ici",
    d: "M0 0h591v405H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "5ssaylye2ck",
    d: "M0 0h591v405H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "u6kupmotacm",
    d: "M0 0h591v405H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "1n8pvmxb3co",
    d: "M0 0h591v405H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ydbz9bavscq",
    d: "M0 0h591v405H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "w5mwjozlics",
    d: "M0 0h591v405H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aj55t62epcu",
    d: "M0 0h591v405H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ypwmlzc3rcw",
    d: "M0 0h591v405H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "lqfu4l74pcy",
    d: "M0 0h591v405H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "htoucanv1cA",
    d: "M0 0h591v405H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ir8b1oyytcC",
    d: "M0 0h591v405H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "isd2epk5hcE",
    d: "M0 0h591v405H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "f1o6h4u71cG",
    d: "M0 0h591v405H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pepk9f0oncI",
    d: "M0 0h591v405H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ywev39ei7cK",
    d: "M0 0h591v405H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "czop5gndhcM",
    d: "M0 0h591v405H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "06do5ok0ycO",
    d: "M0 0h591v405H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "b45a5ubsmcQ",
    d: "M0 0h591v405H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "u1jk1097mcS",
    d: "M0 0h591v405H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "a8qgwex29cU",
    d: "M0 0h591v405H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ib730n04scW",
    d: "M0 0h591v405H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "unx7zbqrscY",
    d: "M0 0h591v405H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "r4o0kfaexda",
    d: "M0 0h591v405H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "izoxwhhp9dc",
    d: "M0 0h591v405H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rx1uj6fkkde",
    d: "M0 0h591v405H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "2n0yjzu40dg",
    d: "M0 0h591v405H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "n6w87ou4cdi",
    d: "M0 0h591v405H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "r8s1qx9xpdk",
    d: "M0 0h591v405H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "dxnh5mzngdm",
    d: "M0 0h591v405H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "27r1n1wd1do",
    d: "M0 0h591v405H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "4u5l4lshldq",
    d: "M0 0h591v405H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "jkd7sydqqds",
    d: "M0 0h591v405H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(46 75)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "i3fov08h1b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#netewilfqa"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M77.99 0c-6.676 0-12.071 5.425-12.071 12.1v145.904h153.417V12.101C219.336 5.408 213.924 0 207.265 0H77.99z",
    fill: "#9C3B83",
    fillRule: "nonzero",
    mask: "url(#i3fov08h1b)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(46 75)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "yw8ao7aazd",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hmnccs95nc"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M249.008 0c-6.677 0-12.071 5.425-12.071 12.1v145.904h153.417V12.101C390.354 5.408 384.942 0 378.283 0H249.008z",
    fill: "#9C3B83",
    fillRule: "nonzero",
    mask: "url(#yw8ao7aazd)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(46 75)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "hsmjynpadf",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#73oxhvrrwe"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M420.75 0c-6.676 0-12.07 5.425-12.07 12.1v145.904h153.416V12.101c0-6.693-5.411-12.101-12.07-12.101H420.75z",
    fill: "#9C3B83",
    fillRule: "nonzero",
    mask: "url(#hsmjynpadf)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(46 75)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "wx36jdardh",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ujcth5jy0g"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M12.088 212.036c-6.676 0-12.071-5.425-12.071-12.101v-23.61h615v23.61c0 6.692-5.412 12.1-12.071 12.1H12.088z",
    fill: "#9C3B83",
    fillRule: "nonzero",
    mask: "url(#wx36jdardh)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#BA75A8",
    fillRule: "nonzero",
    d: "M46 230.773h615v20.585H46z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9C3B83",
    fillRule: "nonzero",
    d: "M172.847 287.036h21.95V394h-21.95zM521.087 287.036h21.95V394h-21.95z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "m330.955 340.5 3.64 46.31h13.565l2.628-46.31zM393.944 340.5l-3.64 46.31h-13.548l-2.646-46.31z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "2lf3adg81j",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bud6ifiuci"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M383.092 92.4s-10.263-4.417-24.923-3.44c-14.644.995-26.59 3.44-26.59 3.44s-13.094 17.397-15.588 22.86c-2.494 5.461-6.707 36.463-6.707 36.463l6.471 27.715 80.952-.067 4.6-52.699s-1.988-18.611-6.453-23.568c-4.466-4.956-11.762-10.705-11.762-10.705",
    fill: "#FFF",
    fillRule: "nonzero",
    mask: "url(#2lf3adg81j)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "9140jct0fl",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#re4djmvb6k"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m391.416 127.987-52.862 46.512a1.148 1.148 0 0 0 1.517 1.72l52.862-46.512a1.148 1.148 0 0 0-1.517-1.72",
    fill: "#FFF",
    fillRule: "nonzero",
    mask: "url(#9140jct0fl)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "whzycgx6in",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#0wq6qpt2cm"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M387.692 130.6a4.154 4.154 0 0 1 2.494-5.31 4.156 4.156 0 0 1 5.308 2.478 4.154 4.154 0 0 1-2.494 5.31 4.122 4.122 0 0 1-5.308-2.478",
    fill: "#FFF",
    fillRule: "nonzero",
    mask: "url(#whzycgx6in)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "abzk458ryp",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gurugep1no"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M379.671 160.624s4.954-2.73 1.988-7.569c-2.982-4.838-8.19-13.52-12.402-13.402-4.213.118-.741 3.725 0 4.585.741.877-12.032 5.21-10.296 7.688 1.736 2.495 16.868 13.79 20.71 8.698",
    fill: "#FFF",
    fillRule: "nonzero",
    mask: "url(#abzk458ryp)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "m376.756 147.998 19.951 17.364-6.066 10.418-17.862-21.073zM345.093 55.649h26.557v24.343h-26.557z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "lkofee7tur",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ch7swusnnq"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M358.961 22.168s-16.868-2.393-18.317 17.398c-1.079 14.903 10.549 31.053 18.317 30.345 0 0 7.297 1.315 13.194-10.166 5.898-11.497 6.387-22.337-.1-31.221-4.399-6.035-13.094-6.356-13.094-6.356",
    fill: "#FFF",
    fillRule: "nonzero",
    mask: "url(#lkofee7tur)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "kknlmq07jt",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#y6dyqdjqys"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M345.093 49.563a3.539 3.539 0 1 1-7.078 0 3.539 3.539 0 1 1 7.078 0",
    fill: "#FFF",
    fillRule: "nonzero",
    mask: "url(#kknlmq07jt)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "zm3x3eng3v",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#kbvuele7qu"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M380.294 49.563a3.539 3.539 0 1 1-7.077 0 3.539 3.539 0 1 1 7.077 0",
    fill: "#FFF",
    fillRule: "nonzero",
    mask: "url(#zm3x3eng3v)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "rr28i49m6x",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#idmob5zv9w"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M357.41 44.59a5.798 5.798 0 1 1-11.593 0c0-3.203 2.595-5.8 5.797-5.8 3.202.017 5.797 2.614 5.797 5.8",
    fill: "#FFF",
    fillRule: "nonzero",
    mask: "url(#rr28i49m6x)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "7vrwr87yrz",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e9wr81qzmy"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M357.41 44.59h-.758c0 1.399-.556 2.647-1.466 3.557a5.018 5.018 0 0 1-3.555 1.467 4.988 4.988 0 0 1-3.556-1.467 5.108 5.108 0 0 1-1.483-3.557c0-1.4.556-2.647 1.483-3.557a5.104 5.104 0 0 1 3.556-1.484c1.398 0 2.645.557 3.555 1.484a5.022 5.022 0 0 1 1.466 3.557h1.517a6.553 6.553 0 0 0-6.555-6.558 6.553 6.553 0 0 0-6.555 6.558 6.553 6.553 0 0 0 6.555 6.558 6.553 6.553 0 0 0 6.555-6.558h-.758z",
    fill: "#FFF",
    fillRule: "nonzero",
    mask: "url(#7vrwr87yrz)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "hz4pj38kcB",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#9yr0lydy7A"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M373.655 44.59a5.798 5.798 0 1 1-11.593 0c0-3.203 2.595-5.8 5.796-5.8 3.202.017 5.797 2.614 5.797 5.8",
    fill: "#FFF",
    fillRule: "nonzero",
    mask: "url(#hz4pj38kcB)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "smnoo2r8hD",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#33virnz2iC"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M373.655 44.59h-.758c0 1.399-.556 2.647-1.483 3.557a5.018 5.018 0 0 1-3.556 1.467 4.988 4.988 0 0 1-3.555-1.467 5.037 5.037 0 0 1-1.483-3.557c0-1.4.556-2.647 1.483-3.557a5.104 5.104 0 0 1 3.555-1.484c1.399 0 2.646.557 3.556 1.484a5.108 5.108 0 0 1 1.483 3.557h1.516a6.553 6.553 0 0 0-6.555-6.558 6.553 6.553 0 0 0-6.555 6.558 6.553 6.553 0 0 0 6.555 6.558 6.553 6.553 0 0 0 6.555-6.558h-.758z",
    fill: "#FFF",
    fillRule: "nonzero",
    mask: "url(#smnoo2r8hD)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "a1kptprwyF",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#1rsr0pew2E"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M358.17 44.876c0-.86.707-1.567 1.566-1.567.86 0 1.567.708 1.567 1.567h1.517a3.086 3.086 0 0 0-3.084-3.085 3.086 3.086 0 0 0-3.084 3.085h1.517z",
    fill: "#FFF",
    fillRule: "nonzero",
    mask: "url(#a1kptprwyF)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "2ui04ht1xH",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#6oqudspqbG"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M340.83 46.916s-6.252-4.484-4.77-8.058c1.483-3.574 1.82-2.09 1.483-3.574-.337-1.483-2.14-8.412 2.393-11.396 4.533-2.967 3.219-5.614 6.185-6.271 2.965-.658 5.274 0 5.274 0s4.128-3.625 9.74-3.304c5.611.337 7.28 6.27 7.28 6.27s6.083-2.477 9.554 2.8c3.471 5.276 1.988 9.406 1.988 9.406s2.815 12.66-4.128 16.42c0 0 1.736-7.199-.489-8.008-2.24-.809-6.841-9.086-5.493-14.026 0 0-6.724-4.13-10.684.658-3.96 4.788-5.948 9.238-9.571 9.238-3.623 0-5.51.995-5.51 6.575s-3.253 3.27-3.253 3.27",
    fill: "#FFF",
    fillRule: "nonzero",
    mask: "url(#2ui04ht1xH)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "x3gjpu6zmJ",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d5wgsn451I"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M350.114 18.915s-6.218-4.636-3.842-6.49c2.36-1.855 3.1-4.822 3.842-6.12S349.744 0 354.748 0c5.005 0 5.746 2.967 8.342 2.596 2.595-.37 3.403-2.41 6.706.742 3.303 3.152-1.634 7.417 0 8.716 1.635 1.298 3.151 6.321-.202 8.53-3.353 2.225-9.453 1.584-9.453 1.584l-10.027-3.253z",
    fill: "#FFF",
    fillRule: "nonzero",
    mask: "url(#x3gjpu6zmJ)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "wshdmvrryL",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fzdr7hqh4K"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M506.509 219.139c0 11.531-9.336 20.87-20.862 20.87-11.526 0-20.861-9.339-20.861-20.87s9.335-20.87 20.861-20.87c11.51 0 20.862 9.339 20.862 20.87",
    fill: "#FFF",
    fillRule: "nonzero",
    mask: "url(#wshdmvrryL)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "4c2u9gk0oN",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#do0jl5h5rM"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M586.18 219.139c0 11.531-9.335 20.87-20.861 20.87s-20.862-9.339-20.862-20.87 9.336-20.87 20.862-20.87c11.526 0 20.862 9.339 20.862 20.87",
    fill: "#FFF",
    fillRule: "nonzero",
    mask: "url(#4c2u9gk0oN)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "2hgupsgmjP",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#qxle8f2agO"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M555.832 213.88c0 15.188-12.318 27.512-27.501 27.512-15.183 0-27.501-12.324-27.501-27.513 0-15.189 12.318-27.512 27.5-27.512 15.2.017 27.502 12.323 27.502 27.512",
    fill: "#FFF",
    fillRule: "nonzero",
    mask: "url(#2hgupsgmjP)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "a6q7yhe70R",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#uj392bsnvQ"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M555.175 254.66h-58.153c-17.812 0-32.253-14.448-32.253-32.267H587.41c.017 17.819-14.425 32.266-32.236 32.266",
    fill: "#FFF",
    fillRule: "nonzero",
    mask: "url(#a6q7yhe70R)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "nzv839z40T",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#4mci3d11dS"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M522.298 176.15v57.605a3.805 3.805 0 0 0 3.809 3.81 3.805 3.805 0 0 0 3.808-3.81v-57.604a3.805 3.805 0 0 0-3.808-3.81 3.805 3.805 0 0 0-3.809 3.81",
    fill: "#FFF",
    fillRule: "nonzero",
    mask: "url(#nzv839z40T)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "mfwn4g24nV",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#vg9sjhepgU"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M136.106 360.747 91.72 228.04l138.6-49.26-86.918-7.198-81.02 21.241c-12.048 4.232-18.384 17.432-14.154 29.485l55.136 157.27 32.742-18.83z",
    fill: "#FFF",
    fillRule: "nonzero",
    mask: "url(#mfwn4g24nV)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "iu6g3i780X",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#xxoziuhyvW"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M61.068 382.022H20.086l64.776-150.981c3.539-11.21 12.166-20.078 23.288-23.871 17.677-6.019 44.234-12.374 68.061-17.533 29.068-6.305 54.11-10.823 54.11-10.823l2.274 4.232c16.817 31.238-4.752 69.337-40.19 70.972l-66.325 3.052-65.012 124.952z",
    fill: "#FFF",
    fillRule: "nonzero",
    mask: "url(#iu6g3i780X)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "hdc9d0simZ",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#l0epu9igyY"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M123.872 94.001s-.219-24.41 19.025-29.114c19.26-4.703 28.209-4.484 37.83-4.248 9.622.219 37.174 4.703 39.634 18.358 2.46 13.655 9.942 99.8 9.942 99.8s-10.7 1.4-60.714 7.334c-25.074 2.984-53.62-7.334-53.62-7.334l7.903-84.796z",
    fill: "#FFF",
    fillRule: "nonzero",
    mask: "url(#hdc9d0simZ)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "83kuw0gzrab",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#5k2vmbe7uaa"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m188.513 51.232 4.533 16.302-4.92 3.456c-8.359 5.866-19.632 5.276-27.316-1.433l3.184-19.151 24.519.826z",
    fill: "#FFF",
    fillRule: "nonzero",
    mask: "url(#83kuw0gzrab)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "anyz7gsb7ad",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#smp6ki5c5ac"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M183.542 14.279s-21.89 3.017-23.727 20.162c-1.853 17.128 4.533 30.901 11.425 32.081 6.892 1.18 18.537-5.715 22.631-22.927 4.297-18.24-1.264-28.659-10.33-29.316",
    fill: "#FFF",
    fillRule: "nonzero",
    mask: "url(#anyz7gsb7ad)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "auku3tpv1af",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#wq4nscc4nae"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M184.03 48.315a5.2 5.2 0 0 1-5.207 5.21 5.2 5.2 0 0 1-5.207-5.21 5.2 5.2 0 0 1 5.207-5.209c2.882.017 5.207 2.344 5.207 5.21",
    fill: "#FFF",
    fillRule: "nonzero",
    mask: "url(#auku3tpv1af)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "d7zvozij2ah",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#j2l1trth0ag"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M184.03 48.315h-.758c0 1.231-.489 2.344-1.298 3.136a4.42 4.42 0 0 1-3.134 1.298 4.361 4.361 0 0 1-3.134-1.298 4.424 4.424 0 0 1-1.298-3.136c0-1.23.489-2.343 1.298-3.135a4.42 4.42 0 0 1 3.134-1.298c1.23 0 2.342.489 3.134 1.298a4.424 4.424 0 0 1 1.298 3.135h1.517a5.967 5.967 0 0 0-5.966-5.967 5.956 5.956 0 0 0-5.965 5.967 5.967 5.967 0 0 0 5.965 5.968 5.956 5.956 0 0 0 5.966-5.968h-.759z",
    fill: "#FFF",
    fillRule: "nonzero",
    mask: "url(#d7zvozij2ah)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "o77kr5352aj",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#l16qglsm7ai"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M170.027 47.961a1.42 1.42 0 0 1 1.416-1.247l.185.017a1.42 1.42 0 0 1 1.247 1.416c0 .067 0 .118-.017.202l1.517.186c.017-.118.017-.253.017-.371a2.93 2.93 0 0 0-2.562-2.917 3.289 3.289 0 0 0-.387-.033 2.93 2.93 0 0 0-2.916 2.562l1.5.185z",
    fill: "#FFF",
    fillRule: "nonzero",
    mask: "url(#o77kr5352aj)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "obd3410h4al",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#uc1yvfyrzak"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M169.606 46.36a5.2 5.2 0 0 1-5.207 5.21 5.2 5.2 0 0 1-5.207-5.21 5.2 5.2 0 0 1 5.207-5.21 5.211 5.211 0 0 1 5.207 5.21",
    fill: "#FFF",
    fillRule: "nonzero",
    mask: "url(#obd3410h4al)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "90xhro5h0an",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#wlt9488kxam"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M169.606 46.36h-.758c0 1.23-.49 2.343-1.298 3.136a4.42 4.42 0 0 1-3.134 1.298 4.361 4.361 0 0 1-3.135-1.298 4.424 4.424 0 0 1-1.297-3.136c0-1.23.489-2.343 1.297-3.136a4.42 4.42 0 0 1 3.135-1.298c1.23 0 2.342.49 3.134 1.298a4.424 4.424 0 0 1 1.298 3.136h1.516a5.967 5.967 0 0 0-5.965-5.968 5.967 5.967 0 0 0-5.965 5.968 5.967 5.967 0 0 0 5.965 5.968 5.967 5.967 0 0 0 5.965-5.968h-.758z",
    fill: "#FFF",
    fillRule: "nonzero",
    mask: "url(#90xhro5h0an)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "4rao1yepzap",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#7152qnqm7ao"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M198.168 44.32a4.33 4.33 0 1 1-8.661 0 4.33 4.33 0 0 1 4.33-4.332 4.32 4.32 0 0 1 4.331 4.332",
    fill: "#FFF",
    fillRule: "nonzero",
    mask: "url(#4rao1yepzap)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "i33msvfbjar",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#z5cwzryojaq"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M181.3 25.186s1.938-7.485 8.224-4.872c10.026 4.147 2.629 24.58 2.629 24.58s15.334-14.38 11.98-24.867c-3.353-10.468-9.369-5.934-9.369-5.934S183.491 1.163 167.87 6.71c-15.62 5.546-12.537 27.445-8.375 32.317 3.556-26.316 21.805-13.84 21.805-13.84",
    fill: "#FFF",
    fillRule: "nonzero",
    mask: "url(#i33msvfbjar)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "5dk59buz1at",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#0u1dsznrfas"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M160.81 51.89c.707 13.385-20.087 37.66 0 40.307 31.663 4.164 31.41-43.882 31.41-43.882s-5.039 12.223-11.56 9.61c-3.74-1.5-8.088-2.445-10.077 0 0 0-.556-2.866-4.33-2.698-3.775.152-4.988-1.702-5.443-3.338",
    fill: "#FFF",
    fillRule: "nonzero",
    mask: "url(#5dk59buz1at)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "wj80p8itkav",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#pdgcqnsxuau"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M165.747 59.981s.337 3.608 5.14 4.249c3.016.404 6.049-2.023 6.049-2.023s-3.539-2.53-6.302-1.113c0 0-2.831-2.664-4.887-1.113",
    fill: "#FFF",
    fillRule: "nonzero",
    mask: "url(#wj80p8itkav)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M309.284 179.371h103.567v77.328H309.284z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "dmaq4gai8ax",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p7t2qrnjpaw"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M362.837 224.904c0 18.713-15.166 33.885-33.87 33.885-18.705 0-33.871-15.172-33.871-33.885 0-18.712 15.166-33.884 33.87-33.884 18.705 0 33.87 15.172 33.87 33.884",
    fill: "#FFF",
    fillRule: "nonzero",
    mask: "url(#dmaq4gai8ax)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "zehzc6etdaz",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b74x754mfay"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M430.578 224.904c0 18.713-15.166 33.885-33.87 33.885-18.705 0-33.871-15.172-33.871-33.885 0-18.712 15.166-33.884 33.87-33.884 18.705 0 33.871 15.172 33.871 33.884",
    fill: "#FFF",
    fillRule: "nonzero",
    mask: "url(#zehzc6etdaz)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "m295.921 232.39 32.034 136.888h26.22l10.145-144.374 4.297 144.374h28.09l32.152-133.72-7.01-20.145h-49.744z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "g6vscm2ypaB",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#51f23p7j2aA"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M376.452 90.95H340.29V76.115a3.733 3.733 0 0 1 3.741-3.743h28.697a3.744 3.744 0 0 1 3.741 3.743V90.95h-.017z",
    fill: "#FFF",
    fillRule: "nonzero",
    mask: "url(#g6vscm2ypaB)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "egnj9umk4aD",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#1vl69oa9uaC"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M383.092 92.4s16.16-1.619 32.034 26.838c15.873 28.456 49.12 85.285 38.353 96.175-10.768 10.89-41.993.405-69.764-45.567l8.594-11.902 10.431 7.434c1.921 1.366 4.23-1.095 2.747-2.916l-6.774-8.311s-3.118-48.821-15.621-61.752",
    fill: "#FFF",
    fillRule: "nonzero",
    mask: "url(#egnj9umk4aD)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "8z7e2up4xaF",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fd36o4utaaE"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m322.782 129.015 52.895 48.569a1.16 1.16 0 0 0 1.618-.068 1.162 1.162 0 0 0-.067-1.618l-52.913-48.568a1.16 1.16 0 0 0-1.617.067 1.146 1.146 0 0 0 .084 1.618",
    fill: "#FFF",
    fillRule: "nonzero",
    mask: "url(#8z7e2up4xaF)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "gfw7jqlltaH",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#i3sfwjutwaG"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M327.972 130.06a4.142 4.142 0 0 0-2.342-5.377 4.12 4.12 0 0 0-5.359 2.326 4.142 4.142 0 0 0 2.342 5.378 4.126 4.126 0 0 0 5.359-2.326",
    fill: "#FFF",
    fillRule: "nonzero",
    mask: "url(#gfw7jqlltaH)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "ie06mfoluaJ",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#7und3x0vaaI"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M331.814 157.27s1.854-10.048 9.302-11.902c2.174-.54 19.092 4.72 16.868 7.94-2.225 3.22-12.639 5.327-15.621 3.962-2.983-1.366-6.589 4.214-6.589 4.214l-12.318 15.78-7.617-10.706 15.975-9.288z",
    fill: "#FFF",
    fillRule: "nonzero",
    mask: "url(#ie06mfoluaJ)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "gktxwexhnaL",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#zarxznxxuaK"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M331.578 92.4s-16.16-1.619-32.034 26.838c-15.873 28.44-49.12 85.285-38.353 96.175 10.768 10.89 41.993.405 69.764-45.567l-8.594-11.902-15.908 11.38c-1.365.977-3.05-.675-2.106-2.058l6.454-9.558c0-.034-.506-32.283 20.777-65.309",
    fill: "#FFF",
    fillRule: "nonzero",
    mask: "url(#gktxwexhnaL)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "m333.718 376.46.826 10.35h13.548l.59-10.35zM376.099 376.46l.59 10.35h13.548l.825-10.35zM369.308 398.712h29.422V405h-29.422zM326.169 398.712h29.422V405h-29.422z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "8ry9f28wqaN",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#mudql72z8aM"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M326.169 398.712c0-8.126 6.589-14.717 14.71-14.717 8.123 0 14.712 6.591 14.712 14.717h-29.422z",
    fill: "#FFF",
    fillRule: "nonzero",
    mask: "url(#8ry9f28wqaN)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "0pbfqpzr6aP",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#l8nnj2b1paO"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M369.308 398.712c0-8.126 6.588-14.717 14.71-14.717 8.123 0 14.712 6.591 14.712 14.717h-29.422z",
    fill: "#FFF",
    fillRule: "nonzero",
    mask: "url(#0pbfqpzr6aP)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "c3j6fihccaR",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bqh0owa0laQ"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M381.457 132.033c.017.101.084 1.517.944 3.068a6.133 6.133 0 0 0 2.022 2.175c.944.607 2.157.994 3.64.978v-.169l-.05.169h.05v-.169l-.05.169.033.016c.084.034.354.253.674.641.607.725 1.382 2.023 2.258 3.675 1.567 2.9 3.522 6.946 6.05 11.413 3.791 6.693 8.846 14.38 15.856 20.752 7.01 6.373 15.992 11.43 27.501 12.796 18.89 2.242 36.365 3.894 49.728 8.041 6.69 2.074 12.318 4.771 16.615 8.43 4.297 3.657 7.296 8.26 8.746 14.312a1.145 1.145 0 0 0 2.224-.54c-1.55-6.507-4.853-11.598-9.487-15.526-6.96-5.9-16.8-9.255-28.394-11.615-11.61-2.36-25.024-3.692-39.162-5.378-9.218-1.096-16.683-4.653-22.833-9.373-9.235-7.08-15.47-16.858-19.85-24.916-2.208-4.03-3.944-7.62-5.393-10.25-.725-1.315-1.382-2.394-2.04-3.22-.336-.405-.656-.759-1.044-1.028-.387-.27-.86-.49-1.415-.506-1.096 0-1.837-.27-2.41-.624a3.506 3.506 0 0 1-1.011-.978c-.388-.556-.624-1.197-.758-1.686a4.458 4.458 0 0 1-.118-.59c-.017-.067-.017-.118-.017-.151v-.034l-.101.017h.1l-.1.017h.1a1.135 1.135 0 0 0-1.212-1.062c-.658-.034-1.13.505-1.096 1.146z",
    fill: "#FFF",
    fillRule: "nonzero",
    mask: "url(#c3j6fihccaR)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "s9x4xfwa0aT",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#lf3o2bcp9aS"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m340.475 170.621 10.212-8.665a1.982 1.982 0 0 1 1.719-.421c2.022.455 6.909 1.348 10.515.135a2.002 2.002 0 0 1 1.82.286l10.28 7.772c.859.657 1.044 1.888.387 2.748-1.247 1.635.404 6.305-1.635 17.043-3.758 19.943-25.293 138.81-56.282 152.448-30.99 13.639-15.621-34.474-9.673-37.947 5.949-3.473 15.621-40.426 26.776-82.352 8.931-33.531 6.59-45.467 5.292-48.889a1.924 1.924 0 0 1 .59-2.158",
    fill: "#FFF",
    fillRule: "nonzero",
    mask: "url(#s9x4xfwa0aT)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "wzu2hf7s0aV",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#u7520dc7jaU"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M131.067 227.67c-7.11-15.83-17.541-28.542-26.759-39.752-13.65-16.606-21.94-27.445-20.289-40.527 1.87-14.785 16.177-24.664 29.624-31.087 4.719-2.259 10.212-4.029 16.363-5.344.067-11.952 2.696-23.247 7.06-34.255-14.29 1.618-26.843 4.956-37.51 10.047-23.44 11.194-37.561 30.75-40.83 56.525-3.505 27.749 5.78 47.776 20.305 65.444 16.818 20.449 32.49 54.94 26.22 88.387-.926 4.956 13.128-13.15 18.335-28.54 3.842-11.33 16.143-2.192 15.452-11.92-1.095-9.963-3.74-19.572-7.97-28.979",
    fill: "#FFF",
    fillRule: "nonzero",
    mask: "url(#wzu2hf7s0aV)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "dprqgcn4taX",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#y11s90rk5aW"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M132.904 70.298s-42.768 42.399-55.912 83.297c-7.01 28.827 5.056 35.014 47.706 8.226l-8.712-22.32-1.921-5.125 24.552-43.41-5.713-20.668z",
    fill: "#FFF",
    fillRule: "nonzero",
    mask: "url(#dprqgcn4taX)"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "m196.298 101.52-4.466-3.642-38.824 8.193-32.085-9.508-4.97 4.957 42.818 14.06z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "m153.008 113.371 43.29-11.851v65.477l-43.29 15.155zM153.008 113.371l-37.056-11.851v63.167l37.056 17.465z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "b1s7bcfrjaZ",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ht7c1vtkdaY"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m100.5 142.62 10.548-9.508c.186-6.878 1.45-10.604 3.809-11.21 1.617-1.265.37 7.653 3.656 6.136 3.27-1.518 10.212-9.744 11.965-8.817 2.578 1.382 2.022 7.603.455 10.991-2.95 6.356-6 9.003-14.037 13.436-4.213 2.31-8.476 5.968-12.824 10.992l-3.572-12.02z",
    fill: "#FFF",
    fillRule: "nonzero",
    mask: "url(#b1s7bcfrjaZ)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "2lv0qi8cibb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#y1ejrcmopba"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m104.696 133.87 11.29 13.554s-7.583 39.836-26.001 41.42c-18.435 1.602-20.744-27.04-10.903-38.2 13.043-14.784 25.614-16.773 25.614-16.773",
    fill: "#FFF",
    fillRule: "nonzero",
    mask: "url(#2lv0qi8cibb)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "4rm7nzw85bd",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#7zir1o5cbbc"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m213.082 143.378-11.476-8.361c-.893-6.81-2.528-10.402-4.937-10.756-1.736-1.095.42 7.654-3 6.474-3.42-1.18-11.172-8.648-12.807-7.536-2.426 1.636-1.23 7.755.691 10.975 3.59 6.018 6.892 8.328 15.352 11.902 4.414 1.871 9.049 5.057 13.885 9.592l2.292-12.29z",
    fill: "#FFF",
    fillRule: "nonzero",
    mask: "url(#4rm7nzw85bd)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "oa0fmrbegbf",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#v0p69k3s0be"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m205.195 134.764-4.87 20.92s25.344 39.18 43.594 33.245c12.588-4.096 12.942-61.515-5.494-92.366-15.3-25.59-11.812-29.906-11.812-29.906l-9.52 39.414 9.52 42.298-21.418-13.605z",
    fill: "#FFF",
    fillRule: "nonzero",
    mask: "url(#oa0fmrbegbf)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "km6l5g2uzbh",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c3zb45hjrbg"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M159.782 52.867s6.622 14.262 42.38 3.507c0 0 11.172-6.71 21.974-1.046 10.801 5.665 12.992 39.094 12.992 39.094s-9.302-20.06-73.05 2.141c-32.151 11.211-33.617-27.141-32.943-38.689.724-7.873 6.117-8.564 8.594-11.666 2.477-3.102 22.53-1.365 20.053 6.66",
    fill: "#FFF",
    fillRule: "nonzero",
    mask: "url(#km6l5g2uzbh)"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M0 392.053v6.659h39.465l21.485-9.828v-6.862z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "nvl0gpr8ibj",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#u32us4pr9bi"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0 392.053c0-8.598 8.998-15.577 20.086-15.577s20.087 6.98 20.087 15.577H0z",
    fill: "#FFF",
    fillRule: "nonzero",
    mask: "url(#nvl0gpr8ibj)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M91.316 391.261h50.132v6.659H91.316z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "d77697ahlbl",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rha27grmdbk"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M91.316 391.26c0-8.597 11.223-15.576 25.057-15.576 13.852 0 25.058 6.979 25.058 15.577H91.316z",
    fill: "#FFF",
    fillRule: "nonzero",
    mask: "url(#d77697ahlbl)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "8tcv8fkuxbn",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#uu5jzyev6bm"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M179.986 395.677c-41.622 0-75.981-7.72-96.86-17.481C32 354.274 1.601 297.934 66.393 274.113c0 0-13.498 31.036-13.312 31.036-.034 0-.236 2.057-3.573 4.552-6.437 10.739 4.853 14.11 11.46 19.707 8.003 6.794 20.878 12.83 33.701 18.628 18.284 8.244 44.723 16.538 94.265 14.734 45.127-1.635 80.632-16.25 105.538-43.426 17.896-19.522 23.406-38.521 23.457-38.707 2.376-8.715 11.374-13.874 20.086-11.497 8.712 2.377 13.869 11.38 11.493 20.095-.287 1.08-6.067 27.664-29.557 53.306-21.35 23.298-62.315 50.507-129.837 52.951-3.421.118-6.808.185-10.128.185",
    fill: "#FFF",
    fillRule: "nonzero",
    mask: "url(#8tcv8fkuxbn)"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "m40.004 392.104 20.946-10.082H33.567z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FDC385",
    fillRule: "nonzero",
    d: "m334.544 340.5 3.64 46.31h13.548l2.646-46.31zM397.516 340.5l-3.64 46.31h-13.548l-2.645-46.31z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "3jbfaa2tqbp",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#t2kvndpaabo"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M386.681 92.4s-10.262-4.417-24.923-3.44c-14.643.995-26.59 3.44-26.59 3.44s-13.094 17.397-15.588 22.86c-2.477 5.461-6.723 36.463-6.723 36.463l6.47 27.715 80.953-.067 4.6-52.699s-1.988-18.611-6.454-23.568c-4.465-4.956-11.745-10.705-11.745-10.705",
    fill: "#F7903D",
    fillRule: "nonzero",
    mask: "url(#3jbfaa2tqbp)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "yo31job6rbr",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#08heyux7rbq"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m395.005 127.987-52.861 46.512a1.148 1.148 0 0 0 1.516 1.72l52.862-46.512a1.148 1.148 0 0 0 .101-1.619c-.438-.472-1.146-.522-1.618-.101",
    fill: "#98428B",
    fillRule: "nonzero",
    mask: "url(#yo31job6rbr)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "kbs8mb835bt",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#uloyeuy2zbs"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M391.281 130.6a4.154 4.154 0 0 1 2.494-5.31 4.156 4.156 0 0 1 5.308 2.478 4.154 4.154 0 0 1-2.494 5.31 4.122 4.122 0 0 1-5.308-2.478",
    fill: "#98428B",
    fillRule: "nonzero",
    mask: "url(#kbs8mb835bt)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "xu31noc8sbv",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#va2mbwvc3bu"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M383.243 160.624s4.955-2.73 1.989-7.569c-2.983-4.838-8.19-13.52-12.403-13.402-4.212.118-.741 3.725 0 4.585.742.877-12.031 5.21-10.296 7.688 1.753 2.495 16.868 13.79 20.71 8.698",
    fill: "#FDC385",
    fillRule: "nonzero",
    mask: "url(#xu31noc8sbv)"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "#FDC385",
    fillRule: "nonzero",
    d: "m380.328 147.998 19.952 17.364-6.067 10.418-17.845-21.073zM348.665 55.649h26.557v24.343h-26.557z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "181mzkpdbbx",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#zvex276pubw"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M362.55 22.168s-16.868-2.393-18.317 17.398c-1.078 14.903 10.549 31.053 18.317 30.345 0 0 7.297 1.315 13.195-10.166 5.898-11.497 6.386-22.337-.101-31.221-4.415-6.035-13.094-6.356-13.094-6.356",
    fill: "#FDC385",
    fillRule: "nonzero",
    mask: "url(#181mzkpdbbx)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "vqabiw9tabz",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#werwx7rnoby"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M348.665 49.563a3.539 3.539 0 1 1-7.077 0 3.539 3.539 0 1 1 7.077 0",
    fill: "#FDC385",
    fillRule: "nonzero",
    mask: "url(#vqabiw9tabz)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "yzwclgmy0bB",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#sq2n3d53dbA"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M383.884 49.563a3.539 3.539 0 1 1-7.078 0 3.539 3.539 0 1 1 7.078 0",
    fill: "#FDC385",
    fillRule: "nonzero",
    mask: "url(#yzwclgmy0bB)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "3mz4egbmjbD",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#4rmy3qw3sbC"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M361 44.59a5.798 5.798 0 1 1-11.593 0c0-3.203 2.595-5.8 5.796-5.8 3.202.017 5.797 2.614 5.797 5.8",
    fill: "#FDC385",
    fillRule: "nonzero",
    mask: "url(#3mz4egbmjbD)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "9g4oguyombF",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#6lwjroo0lbE"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M361 44.59h-.758c0 1.399-.556 2.647-1.466 3.557a5.018 5.018 0 0 1-3.556 1.467 4.988 4.988 0 0 1-3.555-1.467 5.108 5.108 0 0 1-1.483-3.557c0-1.4.556-2.647 1.483-3.557a5.104 5.104 0 0 1 3.555-1.484c1.399 0 2.646.557 3.556 1.484a5.022 5.022 0 0 1 1.466 3.557h1.516a6.553 6.553 0 0 0-6.555-6.558 6.553 6.553 0 0 0-6.555 6.558 6.553 6.553 0 0 0 6.555 6.558 6.553 6.553 0 0 0 6.555-6.558H361z",
    fill: "#DE2227",
    fillRule: "nonzero",
    mask: "url(#9g4oguyombF)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "f7nwafd8abH",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#x6qaocfz0bG"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M377.244 44.59a5.798 5.798 0 1 1-11.593 0c0-3.203 2.595-5.8 5.797-5.8 3.201.017 5.796 2.614 5.796 5.8",
    fill: "#FDC385",
    fillRule: "nonzero",
    mask: "url(#f7nwafd8abH)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "fgvw8rl7abJ",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#4ndedsgwfbI"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M377.244 44.59h-.758c0 1.399-.556 2.647-1.483 3.557a5.018 5.018 0 0 1-3.555 1.467 4.988 4.988 0 0 1-3.556-1.467 5.037 5.037 0 0 1-1.483-3.557c0-1.4.556-2.647 1.483-3.557a5.104 5.104 0 0 1 3.556-1.484c1.398 0 2.645.557 3.555 1.484a5.108 5.108 0 0 1 1.483 3.557h1.517a6.553 6.553 0 0 0-6.555-6.558 6.553 6.553 0 0 0-6.555 6.558 6.553 6.553 0 0 0 6.555 6.558 6.553 6.553 0 0 0 6.555-6.558h-.759z",
    fill: "#DE2227",
    fillRule: "nonzero",
    mask: "url(#fgvw8rl7abJ)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "k863klbaybL",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#28x1xiq30bK"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M361.758 44.876c0-.86.708-1.567 1.567-1.567.86 0 1.568.708 1.568 1.567h1.516a3.086 3.086 0 0 0-3.084-3.085 3.086 3.086 0 0 0-3.083 3.085h1.516z",
    fill: "#DE2227",
    fillRule: "nonzero",
    mask: "url(#k863klbaybL)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "9g0gkjozhbN",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#4anwef3cobM"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M344.402 46.916s-6.252-4.484-4.77-8.058c1.484-3.574 1.82-2.09 1.484-3.574-.337-1.483-2.14-8.412 2.393-11.396 4.533-2.967 3.218-5.614 6.184-6.271 2.966-.658 5.274 0 5.274 0s4.129-3.625 9.74-3.304c5.612.337 7.28 6.27 7.28 6.27s6.083-2.477 9.554 2.8c3.472 5.276 1.989 9.406 1.989 9.406s2.814 12.66-4.129 16.42c0 0 1.736-7.199-.488-8.008-2.241-.809-6.842-9.086-5.494-14.026 0 0-6.723-4.13-10.683.658s-5.949 9.238-9.572 9.238c-3.623 0-5.51.995-5.51 6.575s-3.252 3.27-3.252 3.27",
    fill: "#FFF",
    fillRule: "nonzero",
    mask: "url(#9g0gkjozhbN)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "s2jx5bb3zbP",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#g91vmg11mbO"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M353.687 18.915s-6.218-4.636-3.842-6.49c2.359-1.855 3.1-4.822 3.842-6.12.741-1.298-.371-6.305 4.634-6.305 5.004 0 5.746 2.967 8.341 2.596 2.595-.37 3.404-2.41 6.707.742s-1.635 7.417 0 8.716c1.634 1.298 3.15 6.321-.203 8.53-3.353 2.225-9.453 1.584-9.453 1.584l-10.026-3.253z",
    fill: "#FFF",
    fillRule: "nonzero",
    mask: "url(#s2jx5bb3zbP)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "lj5n4whq7bR",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#19f0qgxh1bQ"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M510.081 219.139c0 11.531-9.335 20.87-20.861 20.87s-20.862-9.339-20.862-20.87 9.336-20.87 20.862-20.87c11.526 0 20.861 9.339 20.861 20.87",
    fill: "#F7903D",
    fillRule: "nonzero",
    mask: "url(#lj5n4whq7bR)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "4r94wdjr1bT",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ec5w2xxm3bS"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M589.77 219.139c0 11.531-9.336 20.87-20.862 20.87-11.526 0-20.861-9.339-20.861-20.87s9.335-20.87 20.861-20.87c11.51 0 20.862 9.339 20.862 20.87",
    fill: "#F9B7B3",
    fillRule: "nonzero",
    mask: "url(#4r94wdjr1bT)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "kih8fd9iibV",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#f4lg36hlqbU"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M559.421 213.88c0 15.188-12.318 27.512-27.5 27.512-15.184 0-27.502-12.324-27.502-27.513 0-15.189 12.318-27.512 27.501-27.512 15.183.017 27.501 12.323 27.501 27.512",
    fill: "#047572",
    fillRule: "nonzero",
    mask: "url(#kih8fd9iibV)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "q4xbulyo7bX",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fakq3y8rqbW"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M558.747 254.66h-58.153c-17.811 0-32.253-14.448-32.253-32.267h122.642c.017 17.819-14.424 32.266-32.236 32.266",
    fill: "#6C9AD1",
    fillRule: "nonzero",
    mask: "url(#q4xbulyo7bX)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "rj2j629dpbZ",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#1s70m695dbY"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M525.87 176.15v57.605a3.805 3.805 0 0 0 3.809 3.81 3.805 3.805 0 0 0 3.808-3.81v-57.604a3.805 3.805 0 0 0-3.808-3.81 3.805 3.805 0 0 0-3.808 3.81",
    fill: "#6C9AD1",
    fillRule: "nonzero",
    mask: "url(#rj2j629dpbZ)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "i3300k1hocb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#scdr4kbiqca"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M139.678 360.747 95.293 228.04l138.6-49.26-86.918-7.198-81.02 21.241c-12.048 4.232-18.384 17.432-14.155 29.485l55.137 157.27 32.741-18.83z",
    fill: "#1B2350",
    fillRule: "nonzero",
    mask: "url(#i3300k1hocb)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "01fbgb165cd",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cftymf1qlcc"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M64.64 382.022H23.677L88.45 231.041c3.539-11.21 12.167-20.078 23.288-23.871 17.677-6.019 44.234-12.374 68.062-17.533 29.068-6.305 54.108-10.823 54.108-10.823l2.275 4.232c16.818 31.238-4.752 69.337-40.19 70.972l-66.325 3.052L64.64 382.022z",
    fill: "#1B2350",
    fillRule: "nonzero",
    mask: "url(#01fbgb165cd)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "5bmzpqq4ucf",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#tg65sf95kce"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M127.461 94.001s-.219-24.41 19.025-29.114c19.26-4.703 28.209-4.484 37.83-4.248 9.623.219 37.174 4.703 39.634 18.358 2.46 13.655 9.943 99.8 9.943 99.8s-10.7 1.4-60.715 7.334c-25.074 2.984-53.62-7.334-53.62-7.334l7.903-84.796z",
    fill: "#DF1F26",
    fillRule: "nonzero",
    mask: "url(#5bmzpqq4ucf)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "a34ge0wuich",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e13m1d175cg"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m192.102 51.232 4.533 16.302-4.92 3.456c-8.359 5.866-19.632 5.276-27.316-1.433l3.185-19.151 24.518.826z",
    fill: "#FDC385",
    fillRule: "nonzero",
    mask: "url(#a34ge0wuich)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "j5k93c0v0cj",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hprxboy9ici"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M187.114 14.279s-21.89 3.017-23.726 20.162c-1.854 17.128 4.533 30.901 11.425 32.081 6.892 1.18 18.536-5.715 22.63-22.927 4.315-18.24-1.263-28.659-10.329-29.316",
    fill: "#FDC385",
    fillRule: "nonzero",
    mask: "url(#j5k93c0v0cj)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "uvccz7bokcl",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#5ssaylye2ck"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M187.603 48.315a5.2 5.2 0 0 1-5.207 5.21 5.2 5.2 0 0 1-5.207-5.21 5.2 5.2 0 0 1 5.207-5.209c2.881.017 5.207 2.344 5.207 5.21",
    fill: "#FDC385",
    fillRule: "nonzero",
    mask: "url(#uvccz7bokcl)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "pfzev4f69cn",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#u6kupmotacm"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M187.603 48.315h-.759c0 1.231-.488 2.344-1.297 3.136a4.42 4.42 0 0 1-3.134 1.298 4.361 4.361 0 0 1-3.135-1.298 4.424 4.424 0 0 1-1.297-3.136c0-1.23.488-2.343 1.297-3.135a4.42 4.42 0 0 1 3.135-1.298c1.23 0 2.342.489 3.134 1.298a4.424 4.424 0 0 1 1.297 3.135h1.517a5.967 5.967 0 0 0-5.965-5.967 5.956 5.956 0 0 0-5.966 5.967 5.967 5.967 0 0 0 5.966 5.968 5.956 5.956 0 0 0 5.965-5.968h-.758z",
    fill: "#DE2227",
    fillRule: "nonzero",
    mask: "url(#pfzev4f69cn)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "xeo4fwgijcp",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#1n8pvmxb3co"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M173.616 47.961a1.42 1.42 0 0 1 1.416-1.247l.185.017a1.42 1.42 0 0 1 1.247 1.416c0 .067 0 .118-.017.202l1.517.186c.017-.118.017-.253.017-.371a2.93 2.93 0 0 0-2.562-2.917 3.289 3.289 0 0 0-.387-.033 2.93 2.93 0 0 0-2.915 2.562l1.5.185z",
    fill: "#DE2227",
    fillRule: "nonzero",
    mask: "url(#xeo4fwgijcp)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "x8e3si6wscr",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ydbz9bavscq"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M173.178 46.36a5.2 5.2 0 0 1-5.207 5.21 5.2 5.2 0 0 1-5.207-5.21 5.2 5.2 0 0 1 5.207-5.21 5.2 5.2 0 0 1 5.207 5.21",
    fill: "#FDC385",
    fillRule: "nonzero",
    mask: "url(#x8e3si6wscr)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "ntive6bc0ct",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#w5mwjozlics"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M173.178 46.36h-.758c0 1.23-.489 2.343-1.298 3.136a4.42 4.42 0 0 1-3.134 1.298 4.361 4.361 0 0 1-3.134-1.298 4.424 4.424 0 0 1-1.298-3.136c0-1.23.489-2.343 1.298-3.136a4.42 4.42 0 0 1 3.134-1.298c1.23 0 2.342.49 3.134 1.298a4.424 4.424 0 0 1 1.298 3.136h1.517a5.967 5.967 0 0 0-5.966-5.968 5.967 5.967 0 0 0-5.965 5.968 5.967 5.967 0 0 0 5.965 5.968 5.967 5.967 0 0 0 5.966-5.968h-.759z",
    fill: "#DE2227",
    fillRule: "nonzero",
    mask: "url(#ntive6bc0ct)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "bq3hj1t0icv",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#aj55t62epcu"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M201.758 44.32a4.33 4.33 0 1 1-8.662 0 4.33 4.33 0 1 1 8.662 0",
    fill: "#FDC385",
    fillRule: "nonzero",
    mask: "url(#bq3hj1t0icv)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "hfrmzunhtcx",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ypwmlzc3rcw"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M184.873 25.186s1.938-7.485 8.223-4.872c10.027 4.147 2.629 24.58 2.629 24.58s15.334-14.38 11.981-24.867c-3.353-10.468-9.37-5.934-9.37-5.934s-11.273-12.93-26.893-7.383c-15.621 5.546-12.538 27.445-8.375 32.317 3.572-26.316 21.805-13.84 21.805-13.84",
    fill: "#FFF",
    fillRule: "nonzero",
    mask: "url(#hfrmzunhtcx)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "7sloxfm9ycz",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#lqfu4l74pcy"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M164.399 51.89c.708 13.385-20.087 37.66 0 40.307 31.663 4.164 31.41-43.882 31.41-43.882s-5.038 12.223-11.56 9.61c-3.74-1.5-8.088-2.445-10.077 0 0 0-.556-2.866-4.33-2.698-3.792.152-5.005-1.702-5.443-3.338",
    fill: "#FFF",
    fillRule: "nonzero",
    mask: "url(#7sloxfm9ycz)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "srh0vtvi7cB",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#htoucanv1cA"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M169.336 59.981s.337 3.608 5.14 4.249c3.016.404 6.05-2.023 6.05-2.023s-3.54-2.53-6.303-1.113c-.017 0-2.831-2.664-4.887-1.113",
    fill: "#FDC385",
    fillRule: "nonzero",
    mask: "url(#srh0vtvi7cB)"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "#1B2350",
    fillRule: "nonzero",
    d: "M312.857 179.371h103.567v77.328H312.857z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "qx94s0okqcD",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ir8b1oyytcC"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M366.41 224.904c0 18.713-15.167 33.885-33.871 33.885-18.705 0-33.871-15.172-33.871-33.885 0-18.712 15.166-33.884 33.87-33.884 18.705 0 33.871 15.172 33.871 33.884",
    fill: "#1B2350",
    fillRule: "nonzero",
    mask: "url(#qx94s0okqcD)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "khuwhd7c2cF",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#isd2epk5hcE"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M434.167 224.904c0 18.713-15.166 33.885-33.87 33.885-18.705 0-33.87-15.172-33.87-33.885 0-18.712 15.165-33.884 33.87-33.884 18.704 0 33.87 15.172 33.87 33.884",
    fill: "#1B2350",
    fillRule: "nonzero",
    mask: "url(#khuwhd7c2cF)"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "#1B2350",
    fillRule: "nonzero",
    d: "m299.494 232.39 32.034 136.888h26.22l10.144-144.374 4.314 144.374h28.074l32.152-133.72-7.01-20.145h-49.728z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "uqzsy9n00cH",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#f1o6h4u71cG"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M380.042 90.95h-36.163V76.115a3.733 3.733 0 0 1 3.741-3.743h28.698a3.744 3.744 0 0 1 3.74 3.743V90.95h-.016z",
    fill: "#F7903D",
    fillRule: "nonzero",
    mask: "url(#uqzsy9n00cH)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "jly9w0qogcJ",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#pepk9f0oncI"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M386.681 92.4s16.16-1.619 32.034 26.838c15.874 28.44 49.12 85.285 38.353 96.175-10.768 10.89-41.993.405-69.763-45.567l8.594-11.902 10.43 7.451c1.921 1.366 4.23-1.096 2.747-2.916l-6.774-8.311c0-.017-3.134-48.838-15.621-61.769",
    fill: "#F7903D",
    fillRule: "nonzero",
    mask: "url(#jly9w0qogcJ)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "8xibf2irjcL",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ywev39ei7cK"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m326.354 129.015 52.896 48.569a1.16 1.16 0 0 0 1.617-.068 1.162 1.162 0 0 0-.067-1.618l-52.912-48.568a1.16 1.16 0 0 0-1.618.067 1.178 1.178 0 0 0 .084 1.618",
    fill: "#98428B",
    fillRule: "nonzero",
    mask: "url(#8xibf2irjcL)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "gcrgmoaetcN",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#czop5gndhcM"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M331.544 130.06a4.142 4.142 0 0 0-2.342-5.377 4.12 4.12 0 0 0-5.359 2.326 4.142 4.142 0 0 0 2.343 5.378 4.12 4.12 0 0 0 5.358-2.326",
    fill: "#98428B",
    fillRule: "nonzero",
    mask: "url(#gcrgmoaetcN)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "0ukrl20phcP",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#06do5ok0ycO"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M335.386 157.27s1.854-10.048 9.302-11.902c2.174-.54 19.092 4.72 16.868 7.94-2.224 3.22-12.638 5.327-15.62 3.962-2.983-1.366-6.59 4.214-6.59 4.214l-12.318 15.78-7.616-10.706 15.974-9.288z",
    fill: "#FDC385",
    fillRule: "nonzero",
    mask: "url(#0ukrl20phcP)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "46g8zgvaocR",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b45a5ubsmcQ"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M335.167 92.4s-16.16-1.619-32.033 26.838c-15.874 28.44-49.121 85.285-38.353 96.175 10.767 10.89 41.992.405 69.763-45.567l-8.594-11.902-15.908 11.38c-1.364.977-3.05-.675-2.106-2.058l6.454-9.558c-.017-.034-.506-32.283 20.777-65.309",
    fill: "#F7903D",
    fillRule: "nonzero",
    mask: "url(#46g8zgvaocR)"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "#EEECE6",
    fillRule: "nonzero",
    d: "m337.307 376.46.81 10.35h13.548l.59-10.35zM379.671 376.46l.59 10.35h13.565l.809-10.35z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M372.897 398.712h29.422V405h-29.422zM329.741 398.712h29.422V405h-29.422z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "2fa35dw3ecT",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#u1jk1097mcS"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M329.741 398.712c0-8.126 6.59-14.717 14.711-14.717 8.123 0 14.711 6.591 14.711 14.717h-29.422z",
    fill: "#F7903D",
    fillRule: "nonzero",
    mask: "url(#2fa35dw3ecT)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "jmftzjrvocV",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a8qgwex29cU"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M372.897 398.712c0-8.126 6.589-14.717 14.71-14.717 8.123 0 14.712 6.591 14.712 14.717h-29.422z",
    fill: "#F7903D",
    fillRule: "nonzero",
    mask: "url(#jmftzjrvocV)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "vwznhucu5cX",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ib730n04scW"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M385.046 132.033c.017.101.085 1.517.944 3.068a6.133 6.133 0 0 0 2.022 2.175c.944.607 2.157.994 3.64.978v-.169l-.05.169h.05v-.169l-.05.169.033.016c.084.034.354.253.674.641.607.725 1.382 2.023 2.258 3.675 1.567 2.9 3.522 6.946 6.05 11.413 3.791 6.693 8.847 14.38 15.857 20.752 7.01 6.373 15.991 11.43 27.5 12.796 18.89 2.242 36.365 3.894 49.728 8.041 6.69 2.074 12.318 4.771 16.615 8.43 4.297 3.657 7.297 8.26 8.746 14.312a1.145 1.145 0 0 0 2.224-.54c-1.55-6.507-4.853-11.598-9.487-15.526-6.96-5.9-16.8-9.255-28.394-11.615-11.61-2.36-25.024-3.692-39.162-5.378-9.217-1.096-16.682-4.653-22.833-9.373-9.234-7.08-15.47-16.858-19.85-24.916-2.208-4.03-3.944-7.62-5.393-10.25-.724-1.315-1.382-2.394-2.039-3.22-.337-.405-.657-.759-1.045-1.028-.387-.27-.859-.49-1.415-.506-1.095 0-1.837-.27-2.41-.624a3.506 3.506 0 0 1-1.01-.978c-.388-.556-.624-1.197-.76-1.686a4.458 4.458 0 0 1-.117-.59c-.017-.067-.017-.118-.017-.151v-.034l-.101.017h.101l-.101.017h.101a1.135 1.135 0 0 0-1.213-1.062c-.657-.034-1.146.505-1.096 1.146z",
    fill: "#047572",
    fillRule: "nonzero",
    mask: "url(#vwznhucu5cX)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "mmhuov1jxcZ",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#unx7zbqrscY"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m344.048 170.621 10.212-8.665a1.982 1.982 0 0 1 1.718-.421c2.023.455 6.91 1.348 10.515.135a2.002 2.002 0 0 1 1.82.286l10.28 7.772a1.95 1.95 0 0 1 .387 2.748c-1.247 1.635.405 6.305-1.634 17.043-3.758 19.943-25.294 138.81-56.283 152.448-30.989 13.639-15.62-34.474-9.672-37.947 5.948-3.473 15.62-40.426 26.776-82.352 8.93-33.531 6.589-45.467 5.291-48.889-.286-.759-.034-1.635.59-2.158",
    fill: "#047572",
    fillRule: "nonzero",
    mask: "url(#mmhuov1jxcZ)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "vvpeqi9b4db",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#r4o0kfaexda"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M134.657 227.67c-7.111-15.83-17.542-28.542-26.76-39.752-13.65-16.606-21.94-27.445-20.288-40.527 1.87-14.785 16.177-24.664 29.624-31.087 4.718-2.259 10.211-4.029 16.362-5.344.068-11.952 2.696-23.247 7.06-34.255-14.289 1.618-26.843 4.956-37.51 10.047-23.456 11.194-37.578 30.75-40.847 56.525-3.505 27.749 5.78 47.776 20.306 65.444 16.817 20.449 32.489 54.94 26.237 88.37-.927 4.956 13.127-13.15 18.334-28.54 3.842-11.33 16.143-2.192 15.452-11.92-1.112-9.946-3.758-19.555-7.97-28.962",
    fill: "#047572",
    fillRule: "nonzero",
    mask: "url(#vvpeqi9b4db)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "cxm4nfiocdd",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#izoxwhhp9dc"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M136.493 70.298s-42.767 42.399-55.911 83.297c-7.01 28.827 5.055 35.014 47.705 8.226l-8.712-22.32-1.921-5.125 24.552-43.41-5.713-20.668z",
    fill: "#DF1F26",
    fillRule: "nonzero",
    mask: "url(#cxm4nfiocdd)"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "#EEECE6",
    fillRule: "nonzero",
    d: "m199.87 101.52-4.465-3.642-38.825 8.193-32.084-9.508-4.955 4.957 42.802 14.06z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6C9AD1",
    fillRule: "nonzero",
    d: "m156.58 113.371 43.29-11.851v65.477l-43.29 15.155z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4D87C2",
    fillRule: "nonzero",
    d: "M156.58 113.371 119.54 101.52v63.167l37.039 17.465z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "l6kshnpn6df",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rx1uj6fkkde"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m104.089 142.62 10.549-9.508c.185-6.878 1.449-10.604 3.808-11.21 1.618-1.265.37 7.653 3.657 6.136 3.269-1.518 10.211-9.744 11.964-8.817 2.578 1.382 2.022 7.603.455 10.991-2.949 6.356-5.999 9.003-14.037 13.436-4.213 2.31-8.476 5.968-12.824 10.992l-3.572-12.02z",
    fill: "#FDC385",
    fillRule: "nonzero",
    mask: "url(#l6kshnpn6df)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "nmq6kern7dh",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#2n0yjzu40dg"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m108.268 133.87 11.29 13.554s-7.583 39.836-26.001 41.42c-18.435 1.602-20.744-27.04-10.903-38.2 13.06-14.784 25.614-16.773 25.614-16.773",
    fill: "#DF1F26",
    fillRule: "nonzero",
    mask: "url(#nmq6kern7dh)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "5o2ye2tnudj",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#n6w87ou4cdi"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m216.67 143.378-11.475-8.361c-.893-6.81-2.527-10.402-4.937-10.756-1.736-1.095.421 7.654-3 6.474-3.42-1.18-11.172-8.648-12.806-7.536-2.427 1.636-1.23 7.755.69 10.975 3.59 6.018 6.893 8.328 15.352 11.902 4.415 1.871 9.049 5.057 13.885 9.592l2.292-12.29z",
    fill: "#FDC385",
    fillRule: "nonzero",
    mask: "url(#5o2ye2tnudj)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "r7pgwblavdl",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#r8s1qx9xpdk"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m208.768 134.764-4.87 20.92s25.344 39.18 43.593 33.245c12.588-4.096 12.942-61.515-5.493-92.366-15.3-25.59-11.813-29.906-11.813-29.906l-9.52 39.414 9.52 42.298-21.417-13.605z",
    fill: "#DF1F26",
    fillRule: "nonzero",
    mask: "url(#r7pgwblavdl)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "7zu92c4sjdn",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dxnh5mzngdm"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M163.37 52.867s6.623 14.262 42.381 3.507c0 0 11.173-6.71 21.974-1.046 10.802 5.665 12.992 39.094 12.992 39.094s-9.302-20.06-73.05 2.141c-32.15 11.211-33.617-27.141-32.943-38.689.725-7.873 6.117-8.564 8.594-11.666 2.477-3.102 22.53-1.365 20.053 6.66",
    fill: "#047572",
    fillRule: "nonzero",
    mask: "url(#7zu92c4sjdn)"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "m64.54 387.265-21.486 7.519H3.572v-5.091l60.968-7.67z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "vl3yiijdydp",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#27r1n1wd1do"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M3.572 392.053c0-8.598 8.999-15.577 20.087-15.577s20.086 6.98 20.086 15.577H3.572z",
    fill: "#F7903D",
    fillRule: "nonzero",
    mask: "url(#vl3yiijdydp)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M94.888 391.261h50.132v6.659H94.888z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "n5otwoo19dr",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#4u5l4lshldq"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M94.888 391.26c0-8.597 11.223-15.576 25.058-15.576 13.851 0 25.057 6.979 25.057 15.577H94.888z",
    fill: "#F7903D",
    fillRule: "nonzero",
    mask: "url(#n5otwoo19dr)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "v22wx5c6edt",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#jkd7sydqqds"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M183.558 395.677c-41.622 0-75.98-7.72-96.86-17.481-51.125-23.922-81.525-80.262-16.732-104.083 0 0-13.498 31.036-13.313 31.036-.033 0-.236 2.057-3.572 4.552-6.437 10.739 4.853 14.11 11.459 19.707 8.004 6.794 20.878 12.83 33.702 18.628 18.283 8.244 44.722 16.538 94.264 14.734 45.127-1.635 80.633-16.25 105.539-43.426 17.895-19.522 23.406-38.521 23.456-38.707 2.376-8.715 11.375-13.874 20.087-11.497 8.712 2.377 13.868 11.38 11.492 20.095-.286 1.08-6.066 27.664-29.557 53.306-21.35 23.298-62.315 50.507-129.837 52.951a292.94 292.94 0 0 1-10.128.185",
    fill: "#047572",
    fillRule: "nonzero",
    mask: "url(#v22wx5c6edt)"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "#F7903D",
    fillRule: "nonzero",
    d: "m43.594 392.104 20.946-10.082h-27.4z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVttKnittingIllustration01);
export default __webpack_public_path__ + "static/media/vtt-knitting-illustration-01.52edc4714b510005ec4199b1e96a0f85.svg";
export { ForwardRef as ReactComponent };